import { useQuery } from '@tanstack/react-query';
import { prefillReviewApi, prefillReviewKeys } from '@client/api/waterlily';

export function usePrefillReview(formReferenceId: string | undefined, enabled = true) {
  return useQuery({
    queryKey: prefillReviewKeys.detail(formReferenceId ?? ''),
    queryFn: () => prefillReviewApi.get(formReferenceId!),
    enabled: Boolean(formReferenceId) && enabled,
  });
}
